import { render, staticRenderFns } from "./ProjetoForm.vue?vue&type=template&id=7e6e7386&"
import script from "./ProjetoForm.vue?vue&type=script&lang=js&"
export * from "./ProjetoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports